/**
 * Every cap the site enforces, in one place, so the form, the API and the
 * privacy policy all quote the same number. Change one here and tsc/tests
 * carry it everywhere.
 */

export const STORY_TITLE_MAX = 120;
export const STORY_TEXT_MIN = 20;
export const STORY_TEXT_MAX = 20_000;
export const NOTE_MAX = 500;
export const MESSAGE_MAX = 5_000;
export const SUPPORT_MESSAGE_MAX = 1_000;
export const DISPLAY_NAME_MAX = 80;
export const LINK_MAX = 2_048;
export const CONTACT_LINKS_MAX = 3;

/** Video: what the contributor sees as the cap, and what tus actually refuses. */
export const VIDEO_MAX_BYTES = 300 * 1024 * 1024;
export const VIDEO_TUS_MAX_BYTES = 350 * 1024 * 1024;
export const VIDEO_MAX_SECONDS = 15 * 60;
/** Chunk size that keeps every tus PATCH far below Traefik's 60 s readTimeout. */
export const VIDEO_CHUNK_BYTES = 6 * 1024 * 1024;

export const AUDIO_MAX_BYTES = 100 * 1024 * 1024;
export const AUDIO_MAX_SECONDS = 10 * 60;

/** Time-trap: a story is never written in under four seconds; a token older than a day is stale. */
export const FORM_TOKEN_MIN_AGE_MS = 4_000;
export const FORM_TOKEN_MAX_AGE_MS = 24 * 60 * 60 * 1000;
/** The client silently refreshes its token past this age so a slow writer is never rejected. */
export const FORM_TOKEN_REFRESH_AFTER_MS = 20 * 60 * 60 * 1000;

/** Social composer limits the captions are pre-fit to. */
export const X_MAX_CHARS = 280;
export const X_URL_CHARS = 23;
export const BLUESKY_MAX_GRAPHEMES = 300;
export const CAPTION_MAX_CHARS = 200;

/** Retention promises made in the privacy policy — enforced by lib/retention. */
export const UNCONFIRMED_SUBSCRIBER_DAYS = 30;
export const CASTING_KEEP_ON_FILE_MONTHS = 24;
export const ORPHAN_MEDIA_HOURS = 24;
export const TUS_PARTIAL_HOURS = 48;
